import React, {useContext} from 'react'

import { AppContext } from "../../AppContext";

import UserSelectBox from "../common/controls/UserSelectBox";

import * as Survey from "survey-react";
import "survey-react/survey.css";
import './css/style.css';

const DocumentForm = (props)=> {

    const [appContext, setAppContext] = useContext(AppContext);

    var mylocalization = Survey.surveyLocalization.locales["en"];
    mylocalization.cleanCaption = "Removel all";

    const survey = new Survey.Model(props.editorItem.templateStr);
    survey.data = props.editorItem.formData;
    
    const adminAttachments = survey.getQuestionByName("AdminAttachments");
    if (adminAttachments)
        adminAttachments.visible = false;

    const onComplete = (result, options)=>{
        props.handleSaveClick({...props.editorItem,formData:result.data});
    }

    return (
        <div className="panel">
            <div className="panel-header">
                {props.editorMode ==="UPDATE"?"Update Document":props.editorMode ==="SAVED"?"Document Saved":"New Document" }
                <div className="push-right">
                    <div className="btn-group">
                    <button type="button" className="btn btn-primary" onClick={props.handleCancel}>{props.editorMode === "SAVED"?"Close":"Cancel"}</button>
                    </div>
                </div>
            </div>
            <div className="panel-body">
                {props.editorMode === "SAVED"?
                <div className="center-container mt-4 mb-4 pb-1em pt-1em success">Document submitted for review</div>:
                <div>
                    {props.editorItem.enableOnBehalf && appContext.user.submitOnBehalf && props.editorMode === 'NEW' &&
                        <UserSelectBox name='submittedFor' label='Document in behalf of (optional) : ' onSelected={props.onUserSelected} labelClass='flex-1' controlClass='flex-3'/>
                    }
                    <Survey.Survey model={survey} onComplete={onComplete}/>
                </div>}
            </div>
            <div className="panel-footer">
                <div className="btn-group">
                    <button type="button" className="btn btn-primary" onClick={props.handleCancel}>{props.editorMode === "SAVED"?"Close":"Cancel"}</button>
                </div>
            </div>
        </div>
    )
}

export default DocumentForm
